import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { Checkbox } from "@tencent/spaui"

/**
 * @class
 */
class SubIndustryDetail extends PureComponent {
  constructor(props) {
    super(props)

    this.onChangeCheckBox = this.onChangeCheckBox.bind(this)
  }

  onChangeCheckBox(event, val) {
    this.props.onChangeSubIndustry(event.target.value.toString(), event.target.checked)
  }

  render() {
    const { disabled, subQualComp, otherQualsComp, addtionalComp, addtionalQuals } = this.props
    const data = this.props.data
    const checkedSubIndustries = this.props.checkedSubIndustries || []
    const isDisplay = subQualComp.length !== 0 || otherQualsComp.length !== 0 || addtionalComp || addtionalQuals
    return (
      <div className="auto-infolist auto-infolist-tt-ver-group" id="subindustries-block">
        <span className="auto-info-tt">业务范围</span>
        <div className="auto-info-des">
          <div className="auto-oncheck-area">
            {data.map((item) => (
              <Checkbox key={item.id} disabled={disabled} name="subIndustries" className="spaui-checkbox" value={item.id} checked={checkedSubIndustries.indexOf(item.id.toString()) > -1} onChange={this.onChangeCheckBox}>
                {item.name}
              </Checkbox>
            ))}
            {isDisplay && (
              <div className="checkin">
                <i className="arrow-code-out"></i>
                <i className="arrow-code-in"></i>
                {subQualComp}
                {otherQualsComp}
                {addtionalComp}
                {addtionalQuals}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

SubIndustryDetail.propTypes = {
  data: PropTypes.array.isRequired,
  checkedSubIndustries: PropTypes.array,
  onChangeSubIndustry: PropTypes.func.isRequired,
}

export default SubIndustryDetail
